import React, { useState, useEffect, useCallback } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { DefaultPerPageValue, PerPage } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import { getAllDeliverableList, getAllNonLegalDeliverableList } from "../../api/casp/deliverable";
import Search from "../../Components/casp/common/Search";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { getAllProject } from "../../api/casp/project";
import { ProjectDeliverableStatus, ProjectStatuses } from "../../constants/Status";
import { Autocomplete, TextField } from "@mui/material";
import SubmitDeliverable from "../../Components/ProjectSubmission/submitDeliverable";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { getProjectDeliverableDetails } from "../../api/casp/projectDeliverable";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import SubmitSecondDeliverable from "../../Components/ProjectSubmission/submitSecondDeliverable";
import { getAllPortfolios } from "../../api/casp/portfolio";
import { Role } from "../../constants/Role";
import { useSelector } from "react-redux";

const NonLegalDocuments = (props) => {
  const [documents, setDocuments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [project, setProject] = useState();
  const [status, setStatus] = useState();
  const [deliverableName, setDeliverableName] = useState();
  const [deliverables, setDeliverables] = useState([]);
  const [filterData, setFilterData] = useState({
    filterFields: [],
    filterInputs: []
  });
  const [searchedTerm, setSearchedTerm] = useState(null);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [selectedDeliverable, setSelectedDeliverable] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [action, setAction] = useState()
  const location = useLocation();
  const highlightRow = location?.state?.moduleRelation ? JSON.parse(location?.state?.moduleRelation) : "";
  const [portfolio,setPortfolio] = useState()
  // const handleDownload = async (deliverableId, projectId) => {
  //   try {
  //     const response = await getDeliverableDocumentDetails(deliverableId, {
  //       projectId: projectId,
  //       type: 'Non Legal'
  //     });
  //     const storageLink = response.data.data[0].storageLink;
  //     const downloadUrl = getUrl(storageLink);
  //     window.open(downloadUrl, '_blank');
  //   } catch (error) {
  //     console.error('Error downloading document:', error);
  //   }
  // };
  const loggedInUser = useSelector((state) => state.Profile.user);

  const handleCloseDrawer = (_, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setDrawerOpen(false);
    setSelectedDeliverable();
    setAction()
  };

  const deliverableRefresh = async () => {
    setTriggerData(+new Date());
  };
  const fetchDeliverableList = async (params) => {
    const deliverables = await getAllDeliverableList(params)
    setDeliverables(deliverables.data.data.data)
  }

  const fetchDeliverableDetails = async (deliverableId, projectId) => {
    try {
      const response = await getProjectDeliverableDetails(deliverableId, {
        projectId: projectId,
      });
      setSelectedDeliverable(response.data.data);
      setAction("View");
      setDrawerOpen(true);
    } catch (error) {
      console.error("Error fetching deliverable details:", error);
      toast.error("Failed to fetch deliverable details");
    }
  };

  const columns = [
    {
      field: "deliverableName",
      headerName: props.t("Deliverable Name"),
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) =>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor:
              highlightRow?.id === params.row?.id ? "#cce6ff" : "",
            padding: "0 10px",
          }}
        >
          <button
            onClick={() => {
              fetchDeliverableDetails(params.row.id, params.row.projectId);
            }}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
              background: "none",
              border: "none",
              padding: 0,
              font: "inherit",
            }}
            className="MuiDataGrid-cellContent"
          >
            {params.row.deliverableName}
          </button>

        </div>
    },
    {
      field: "projectName",
      headerName: props.t("Startup Name"),
      flex: 1,
    },
    {
      field: "currentStatus",
      headerName: props.t("Status"),
      flex: 1,
      renderCell: (params) => params.value ? props.t(params.value) : ""
    },
    {
      field: "description",
      headerName: props.t("Description"),
      flex: 1,
      renderCell: (params) => params.value || "-"
    },
    {
      field: 'action',
      headerName: props.t('Actions'),
      sortable: false,
      width: 100,
      filterable: false,
      hideable: false,
      renderCell: (params) =>
        <div
          className="proSubmissionActions newActionIcons"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
        >
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
              fetchDeliverableDetails(params.row.id, params.row.projectId)
            }}
          >
            <RemoveRedEyeOutlinedIcon />
          </div>
        </div >
    }
  ];

  const fetchDocuments = useCallback(async (filter) => {
    try {
      setIsLoading(true);
      let params
      if (filter) {
        params = {
          // ...filter,
          filterFields: [
            ...(filter.filterFields || []),
            ...(filterData.filterFields || [])
          ],
          filterInputs: [
            ...(filter.filterInputs || []),
            ...(filterData.filterInputs || [])
          ],
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      } else {
        params = {
          ...filterData,
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      }
      const response = await getAllNonLegalDeliverableList(params);
      const { data, meta } = response.data.data;

      const formattedData = data.map((doc) => ({
        id: doc.id,
        deliverableName: doc.deliverable.name,
        projectName: doc.project.name,
        currentStatus: doc.currentStatus,
        description: doc.description,
        projectId: doc.project.id,
        projectUniqueId: doc.project.uniqueProjectId,
        deliverableId: doc.deliverable.id
      }));

      setDocuments(formattedData);
      setRowCount(meta.total);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [page, rowsPerPage, filterData, search]);

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    await fetchDocuments();
  };

  useEffect(() => {
    const filter = location?.state?.filterData ? JSON.parse(location.state?.filterData) : null
    fetchDocuments(filter);
    fetchDeliverableList({excludeFilterFields: ['deliverableOrder'], excludeFilterInputs: ['1']});
  }, [fetchDocuments, triggerData]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Helmet>
            <title>{props.t("Deliverables")} | NTDP</title>
          </Helmet>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb
                title={<span style={{ fontSize: '16px' }}>{props.t("Deliverables")}</span>}
                pageTitle={props.t("Documents")}
              />
            </div>
            <div className="d-flex justify-content-end ongoingSearchField">
              <div className="me-2">
                <Autocomplete
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={deliverableName}
                  size="small"
                  sx={{ width: "200px" }}
                  options={deliverables.map(deliverable => ({
                    value: deliverable.name,
                    label: props.t(deliverable.name)
                  }))}
                  onChange={(_, item) => {
                    setDeliverableName(item);
                    const newFilterData = {
                      filterFields: [...filterData.filterFields],
                      filterInputs: [...filterData.filterInputs]
                    };

                    // Clean up previous deliverableName if it exists (to avoid duplicates)
                    const index = newFilterData.filterFields.indexOf("deliverableName");
                    if (index !== -1) {
                      newFilterData.filterFields.splice(index, 1);
                      newFilterData.filterInputs.splice(index, 1);
                    }

                    // Add project filter if it exists
                    if (project) {
                      newFilterData.filterFields.push("projectName");
                      newFilterData.filterInputs.push(project.name);
                    }

                    // Add status filter if selected
                    if (status) {
                      newFilterData.filterFields.push("currentStatus");
                      newFilterData.filterInputs.push(status.value);
                    }

                    // Add deliverable name filter if selected
                    if (item) {
                      newFilterData.filterFields.push("deliverableName");
                      newFilterData.filterInputs.push(item.value);
                    }

                    setFilterData(newFilterData);
                    setTriggerData(+new Date());
                  }}
                  renderInput={(params) => <TextField {...params}
                    label={props.t("Deliverable Name")}
                  />}
                />
              </div>
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Cohort")}
                  sx={{
                  width: 150,
                  }}
                  searchEnabled={false}
                  listCall={getAllPortfolios}
                  disableClearable={!portfolio}
                  defaultValue={portfolio}
                  apiParams={{
                      order: "updatedAt",
                      direction: "desc",
                      ...(![
                          Role.PROJECT_MANAGER,
                          Role.EPMO_MANAGER,
                          Role.ROOT_ADMIN,
                          Role.VICE_PRESIDENT,
                          Role.PRESIDENT,
                          Role.PROGRAM_MANAGER,
                          Role.EPMO_OFFICER,
                          Role.MENTOR
                      ].includes(loggedInUser?.role?.name) && {
                          filterFields: "portfolioUser",
                          filterInputs: loggedInUser.id,
                      }),
                  }}
                  emitItem={(newValue) => {
                    setPortfolio(newValue);
                    const newFilterData = {
                      filterFields: [...filterData.filterFields],
                      filterInputs: [...filterData.filterInputs]
                    };

                    const index = newFilterData.filterFields.indexOf("portfolio");
                    if (index !== -1) {
                      newFilterData.filterFields.splice(index, 1);
                      newFilterData.filterInputs.splice(index, 1);
                    }
                    // Maintain status filter if it exists
                    if (status) {
                      newFilterData.filterFields.push("currentStatus");
                      newFilterData.filterInputs.push(status.value);
                    }

                    //Add deliverable name if exists
                    if (deliverableName) {
                      newFilterData.filterFields.push("deliverableName");
                      newFilterData.filterInputs.push(deliverableName.value);
                    }

                    if (project) {
                      newFilterData.filterFields.push("projectName");
                      newFilterData.filterInputs.push(project.name);
                    }
                    
                    if(newValue){
                      newFilterData.filterFields.push("portfolio");
                      newFilterData.filterInputs.push(newValue.id);
                    }
                      setFilterData(newFilterData);
                      setPage(0)
                      setTriggerData(+new Date());
                  }}
                />
              </div>
              <div className="me-2">
                <Autocomplete
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  size="small"
                  sx={{ width: "150px" }}
                  options={Object.values(ProjectDeliverableStatus).map(statusValue => ({
                    value: statusValue,
                    label: props.t(statusValue)
                  }))}
                  onChange={(_, item) => {
                    setStatus(item);
                    const newFilterData = {
                      filterFields: [...filterData.filterFields],
                      filterInputs: [...filterData.filterInputs]
                    };

                    const index = newFilterData.filterFields.indexOf("currentStatus");
                    if (index !== -1) {
                      newFilterData.filterFields.splice(index, 1);
                      newFilterData.filterInputs.splice(index, 1);
                    }

                    if (portfolio) {
                      newFilterData.filterFields.push("portfolio");
                      newFilterData.filterInputs.push(portfolio.id);
                    }

                    // Add project filter if it exists
                    if (project) {
                      newFilterData.filterFields.push("projectName");
                      newFilterData.filterInputs.push(project.name);
                    }

                     //Add deliverable name if exists
                    if (deliverableName) {
                      newFilterData.filterFields.push("deliverableName");
                      newFilterData.filterInputs.push(deliverableName.value);
                    }

                    // Add status filter if selected
                    if (item) {
                      newFilterData.filterFields.push("currentStatus");
                      newFilterData.filterInputs.push(item.value);
                    }

                    setFilterData(newFilterData);
                    setTriggerData(+new Date());
                  }}
                  renderInput={(params) => <TextField {...params}
                    label={props.t("Status")}
                  />}
                />
              </div>
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Startup Name")}
                  searchEnabled={false}
                  disableClearable={!project}
                  listCall={getAllProject}
                  defaultValue={project}
                  size="small"
                  sx={{ width: "150px" }}

                  emitItem={(newValue) => {
                    setProject(newValue);

                    const newFilterData = {
                      filterFields: [...filterData.filterFields],
                      filterInputs: [...filterData.filterInputs]
                    };

                    const index = newFilterData.filterFields.indexOf("projectName");
                    if (index !== -1) {
                      newFilterData.filterFields.splice(index, 1);
                      newFilterData.filterInputs.splice(index, 1);
                    }

                    if (portfolio) {
                      newFilterData.filterFields.push("portfolio");
                      newFilterData.filterInputs.push(portfolio.id);
                    }

                    // Maintain status filter if it exists
                    if (status) {
                      newFilterData.filterFields.push("currentStatus");
                      newFilterData.filterInputs.push(status.value);
                    }

                    //Add deliverable name if exists
                    if (deliverableName) {
                      newFilterData.filterFields.push("deliverableName");
                      newFilterData.filterInputs.push(deliverableName.value);
                    }

                    // Add project filter if selected
                    if (newValue) {
                      newFilterData.filterFields.push("projectName");
                      newFilterData.filterInputs.push(newValue.name);
                    }

                    setFilterData(newFilterData);
                    setTriggerData(+new Date());
                  }}
                  apiParams={searchedTerm && searchedTerm !== "undefined" ? {
                    filterFields: ["name", 'status'],
                    filterInputs: [searchedTerm, ProjectStatuses.ONGOING]
                  } : {
                    filterFields: ['status'],
                    filterInputs: [ProjectStatuses.ONGOING]
                  }}
                  handleInputChange={(data) => setSearchedTerm(data)}
                />
              </div>
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div style={{ height: 450, width: '100%' }}>
                    {!isLoading ? (
                      documents.length ? (
                        <DataGrid
                          rows={documents}
                          columns={columns}
                          // pageSize={rowsPerPage}
                          // page={page}
                          rowCount={rowCount}
                          // onPageChange={(newPage) => setPage(newPage)}
                          // onPageSizeChange={(newPageSize) => setRowsPerPage(newPageSize)}
                          pagination
                          paginationModel={{ page: page, pageSize: rowsPerPage }}
                          onPaginationModelChange={(newModel) => {
                            setPage(newModel.page);
                            setRowsPerPage(newModel.pageSize);
                          }}
                          paginationMode="server"
                          disableSelectionOnClick
                          disableColumnMenu
                          autoHeight
                          pageSizeOptions={PerPage}
                          getRowId={(row) => row.id}
                          localeText={{
                            noRowsLabel: props.t("No rows"),
                            MuiTablePagination: {
                              labelRowsPerPage: props.t("Rows per page:"),
                            },
                          }}
                        />
                      ) : (
                        <NodataFound />
                      )
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {drawerOpen && selectedDeliverable && selectedDeliverable.deliverable.deliverableOrder === 2 && (
        <SubmitSecondDeliverable
          isOpen={drawerOpen}
          handleClose={handleCloseDrawer}
          selectedRow={selectedDeliverable}
          refresh={deliverableRefresh}
          isDisabled={true}
          action={action}
        />
      )}

      {drawerOpen && selectedDeliverable && selectedDeliverable.deliverable.deliverableOrder !== 1
        && selectedDeliverable.deliverable.deliverableOrder !== 2 && (
          <SubmitDeliverable
            isOpen={drawerOpen}
            handleClose={handleCloseDrawer}
            selectedRow={selectedDeliverable}
            refresh={deliverableRefresh}
            isDisabled={true}
            action={action}
          />
        )}
    </React.Fragment>
  );
};

export default withTranslation()(NonLegalDocuments);
